import _ from 'lodash';
import moment from 'moment';
import CONSTANTS from '../constants';

class ViewHelper {
	getInitials(member){
		if(!member)
			return '';
		return `${member.first_name[0]}${member.last_name[0]}`;
	}

	getFullName(member) {
		if(!member)
			return '';
		return `${member.first_name} ${member.last_name}`;
	}

	getFormattedPrimaryPhone(member) {
		if (!member || !member.primary_phone) {
			return '';
		}

		let digits = member.primary_phone.replace(/\D/g, '');

		if (digits.length === 11 && digits.charAt(0) === '1') {
			digits = digits.substring(1);
		}

		if (digits.length === 10) {
			return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
		}

		return member.primary_phone;
	}

	getFormattedAddress(member) {
		if(!member)
			return '';
		return `${member.address} ${member.city} ${member.state}, ${member.zip}`;
	}

	getBirthday(member) {
		if(member && member.dob) {
			return moment(member.dob, CONSTANTS.DATE.FORMAT.DEFAULT).format('Do MMM');
		}
		return '';
	}

	getFormattedDate(date, format=CONSTANTS.DATE.FORMAT.SERVER) {
		if(date) {
			return moment(date, format).format(CONSTANTS.DATE.FORMAT.DISPLAY);
		}
		return '';
	}

    getFormattedTime(time, format=CONSTANTS.TIME.FORMAT.SERVER) {
        if(time) {
            return moment(time, format).format(CONSTANTS.TIME.FORMAT.DISPLAY);
        }
        return '';
    }

	getFormattedDateTime(dateTime, format=`${CONSTANTS.DATE.FORMAT.SERVER} ${CONSTANTS.TIME.FORMAT.SERVER}`) {
		if(dateTime) {
			return moment(dateTime, format).format(`${CONSTANTS.DATE.FORMAT.DISPLAY} ${CONSTANTS.TIME.FORMAT.DISPLAY}`);
		}
		return '';
	}

    getStandardDate(formattedDate) {
        if(formattedDate) {
            return moment(formattedDate, CONSTANTS.DATE.FORMAT.DISPLAY).format(CONSTANTS.DATE.FORMAT.DEFAULT);
        }
        return '';
	}

	getActiveMemberships (memberships) {
		return _.sortByOrder(_.filter(memberships, (membership) => this.membershipHasActiveStatus(membership.status_code)), ['start_date'], [false]);
	}

	getInActiveMemberships (memberships) {
		return _.sortByOrder(_.filter(memberships, (membership) => !this.membershipHasActiveStatus(membership.status_code)), ['start_date'], [false]);
	}

	getActiveAccounts (accounts) {
		return _.sortByOrder(_.filter(accounts, (account) => this.accountHasActiveStatus(account.account_active)), ['entered_on'], [false]);
	}

	getInActiveAccounts (accounts) {
		return _.sortByOrder(_.filter(accounts, (account) => !this.accountHasActiveStatus(account.account_active)), ['entered_on'], [false]);
	}

	membershipHasActiveStatus (statusCode) {
		return parseInt(statusCode, 10) === CONSTANTS.STATUS.MEMBERSHIP.ACTIVE;
	}

    accountHasActiveStatus (statusCode) {
        return parseInt(statusCode, 10) === CONSTANTS.STATUS.MEMBERSHIP.ACTIVE;
    }

	getSortedMemberships(memberships) {
		if(!memberships)
			return [];
		return this.getActiveMemberships(memberships).concat(this.getInActiveMemberships(memberships));
	}

	getSortedAccounts(accounts) {
		if(!accounts)
			return [];
		return this.getActiveAccounts(accounts).concat(this.getInActiveAccounts(accounts));
	}

	formatCurrency(number, currency = CONSTANTS.DEFAULTS.CURRENCY) {
		if(number || number !== null) {
			return `${currency}${parseFloat(Math.round(number * 100) / 100).toFixed(2)}`;
		}
		return ''
	}
}

export default new ViewHelper();